import { isSubscriptionTiersEnabled } from 'bundles/coursera-plus/utils/subscriptionTiersUtils';
import { useSubscriptionsByUser } from 'bundles/coursera-plus/utils/withSubscriptionsByUser';
import pageHeaderExperiments from 'bundles/epic/clients/pageHeader';

export const courseraPlusReferralOfferEnabled = () => pageHeaderExperiments.get('showCourseraPlusReferralOffer');

export const useShouldShowCourseraPlusReferralOffer = () => {
  const isReferralEpicEnabled =
    courseraPlusReferralOfferEnabled() && !isSubscriptionTiersEnabled({ skipProductTypeCheck: true });
  const { subscriptions } = useSubscriptionsByUser(!isReferralEpicEnabled);

  const hasOwnedLiteOrPlusBefore = subscriptions?.find(
    (subscription) => subscription.isCourseraPlusSubscription || subscription.isCourseraLiteSubscription
  );

  return {
    shouldShowCourseraPlusReferralOffer: isReferralEpicEnabled && !hasOwnedLiteOrPlusBefore,
  };
};
